// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"978":"9771e618","2314":"9edcb704","3611":"e5f8f901","3953":"d321de1c","5497":"9edcb704","6123":"95b16c32","7068":"d906482a","7587":"57660edf","7697":"a31ed7d3","8823":"bad5ee0b","9001":"57660edf"}[chunkId] + ".chunk.css";
};